import React from 'react'
import { NavLink } from "react-router-dom";
import "../Css/App.css";
import Logo from '../Images/logo.png'

const Header = () => {
    return (
        <header className="header">
            <div className="header-container">
                <div className="logo">
                    <NavLink to="/" end >
                        <img src={Logo} alt="Shyam Rugs" />
                    </NavLink>
                </div>

                <span className='brandname'>Royal Rugs</span>

                <input type="checkbox" id="menu-toggle" />

                <label htmlFor="menu-toggle" className="menu-icon">
                    <i className="bi bi-list"></i>
                </label>

                <nav className="nav">
                    <label htmlFor="menu-toggle" className="close-btn">
                        <i className="bi bi-x-lg"></i>
                    </label>

                    <NavLink to="/" end className="nav-link">
                        Home
                    </NavLink>
                    <NavLink to="/contact" className="nav-link">
                        Contact Us
                    </NavLink>
                </nav>
            </div>
        </header>
    )
}

export default Header;